define([
        'jQuery',
        'library/fcse-compatibility/object',
        'clientComponents/googletagmanager/GtmBase',
        'library/fcse-util/url',
        'moment'
    ],
    /**
     * @param $
     * @param Object
     * @param {GtmBase} GtmBase
     * @param Url
     * @param moment
     * @returns {GtmListingPage}
     */
    function ($, Object, GtmBase, Url, moment) {

        /**
         * @param options
         * @extends Object
         * @extends OptionsMixin
         * @constructor
         */
        function GtmListingPage(options) {
            var self = this;
            var defaultOptions = {};
            //Add default options and custom options
            this.addOptions(defaultOptions, options);

            this.option('offersUpdateRoutes', [
                'allt_frontend.package.destination.accordion_offers',
                'allt_frontend.hotel.destination.accordion_offers']);
            this.option('accordionUpdateRoutes', [
                'allt_frontend.package.destination.accordion_content',
                'allt_frontend.hotel.destination.accordion_content']);

            options.stateHandler.on('success', function (responseContent, requestData) {
                if (self.option('offersUpdateRoutes').indexOf(requestData.route) === -1) {
                    return false;
                }

                self.onAccordionOffersUpdate(requestData.queryParams.groupNames, true);
            });

            $('body').on('click', '[data-fcse-role="hotel-link"]', $.proxy(this._onClickHotelLink, this));
            $('body').on('click', 'div[data-fcse-role="flightdestionationlist-offers"] a.flightrow', $.proxy(this._onClickFlightLink, this));

            let groupNames;
            var location = new Url();
            if (typeof location.query.groupNames !== "undefined") {
                if ($('[data-fcse-role="accordion--contentnode"][data-group-name="'
                        + location.query.groupNames + '"]').length) {
                    groupNames = location.query.groupNames;
                }
            }
            self.onAccordionOffersUpdate(groupNames, false);
        }

        GtmListingPage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmListingPage.prototype */{
            onAccordionOffersUpdate: function (groupNames, isUpdate) {
                try {
                    let $responseContent = [];
                    const isFlightDestination = (this.option('siteArea') === 'flightDestination');

                    if (!isFlightDestination) {
                        $responseContent = $('[data-fcse-role="accordion--contentnode"][data-group-name="'
                            + groupNames + '"]');
                    } else  {
                        $responseContent = $('.accordion[data-group-name="' + groupNames + '"]');
                    }

                    const canonicalUrl = new Url(window.location.href);

                    if (!$responseContent.length) {
                        if ($(['data-fcse-role="accordion--node--header"']).length) {
                            if (this.option('pageType') === 'searchResultPage') {
                                this.trackData({
                                    canonicalUrl: canonicalUrl.toString(),
                                    pageType: 'searchResultPage',
                                    searchQuery: canonicalUrl.query.searchValue,
                                    products: []
                                });
                            } else {
                                this.trackEvent({
                                    canonicalUrl: canonicalUrl.toString(),
                                    pageType: 'listingPage',
                                    listName: 'Filter/Alle Reiseziele',
                                    products: []
                                });
                            }
                        }

                        return;
                    }

                    let $offers = [];
                    if (!isFlightDestination) {
                        $offers = $responseContent.find('[data-fcse-role="offer-item"][data-gtm-product]');
                    } else {
                        $offers = $responseContent.find('div[data-fcse-role="flightdestionationlist-offers"] a.flightrow');
                    }

                    let data = {};
                    if ($offers.length) {
                        if (isUpdate) {
                            let products = [];
                            if (!isFlightDestination) {
                                products = this._getProductsData($offers, $offers.first().data('group-name'));
                            } else {
                                products = this._getFlightOnlyProductsData($offers);
                            }
                            this.trackEvent({
                                event:'productPush',
                                eventLabel: products
                            });
                        } else {
                            if (typeof canonicalUrl.query.groupNames === "undefined") {
                                canonicalUrl.query.groupNames = groupNames;
                            }

                            data = {
                                canonicalUrl: canonicalUrl.toString()
                            };

                            if (!isFlightDestination) {
                                const products = this._getProductsData($offers, $offers.first().data('group-name'));
                                if (this.option('pageType') === 'searchResultPage') {
                                    data = $.extend(data, {
                                        searchQuery: canonicalUrl.query.searchValue,
                                        searchResults: $responseContent.find('[data-gtm-results-total]').data('gtm-results-total'),
                                        products: products
                                    });
                                } else {
                                    data = $.extend(data, {
                                        listName: 'Filter/' + $offers.first().data('group-name'),
                                        products: products
                                    });
                                }
                            } else {
                                const products = this._getFlightOnlyProductsData($offers);
                                if (this.option('pageType') === 'searchResultPage') {
                                    data = $.extend(data, {
                                        searchQuery: canonicalUrl.query.searchValue,
                                        searchResults: $responseContent.find('[data-gtm-results-total]').data('gtm-results-total'),
                                        products: products
                                    });
                                } else {
                                    data = $.extend(data, {
                                        listName: 'Filter/' + $offers.first().data('group-name'),
                                        products: products
                                    });
                                }
                            }
                            this.trackData(data);
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            _getProductsData: function ($offers, listName) {
                var self = this;
                var products = [];
                var siteArea = this.option('siteArea');
                $offers.each(function (i) {
                    var $offerItem = $(this);
                    var data = $offerItem.data('gtm-product');
                    var position = (i + 1);
                    data = $.extend(data, JSON.parse($offerItem.find('[data-fcse-favorites]').data('fcse-favorites').data));

                    try {
                        switch (siteArea) {
                            case 'packageDestination':
                                products.push(self._createPackageDestinationProduct(data, listName, position));
                                break;
                            case 'hotelDestination':
                                products.push(self._createHotelDestinationProduct(data, listName, position));
                                break;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });

                return products;
            },
            _createPackageDestinationProduct: function(data, listName, position) {
                var product = {
                    name: data.hotel.name,
                    id: data.hotel.id, //if available otherwise repeat the hotelname
                    brand: data.hotel.offers["0"].tourOperator.code,
                    variant: data.hotel.offers["0"].departureFlight.departureAirport.code +
                    '-' + data.hotel.offers["0"].departureFlight.arrivalAirport.code,
                    price: data.offer.price.total, //in this case the cheapest Offer price of the product as shown in the list
                    category: 'package/' + data.hotel.location.country.name + '/' + data.hotel.location.city.name,
                    list: listName, // i.e. 'Hurghada'
                    position: position, //i.e.. '1'. only on list pages
                    adults: data.productSearch.travellers.adults.length,
                    durationOfStay: data.hotel.offers["0"].lengthOfStay,
                    travelDates: data.offer.period.from + '/' + data.offer.period.to
                };

                if (typeof data.productSearch.travellers.children !== "undefined") {
                    product.children = data.productSearch.travellers.children.length;
                }

                return product;
            },
            _createHotelDestinationProduct: function(data, listName, position) {
                var product = {
                    name: data.hotel.name,
                    id: data.hotel.id, //if available otherwise repeat the hotelname
                    brand: data.hotel.offers["0"].tourOperator.code,
                    variant: data.hotel.location.city.name,//data.hotel.offers["0"].nearestAirportDLC,
                    price: data.offer.price.total, //in this case the cheapest Offer price of the product as shown in the list
                    category: 'package/' + data.hotel.location.country.name + '/' + data.hotel.location.city.name,
                    list: listName, // i.e. 'Hurghada'
                    position: position, //i.e.. '1'. only on list pages
                    adults: data.productSearch.travellers.adults.length,
                    durationOfStay: data.hotel.offers["0"].lengthOfStay,
                    travelDates: data.offer.period.from + '/' + data.offer.period.to
                };

                if (typeof data.productSearch.travellers.children !== "undefined") {
                    product.children = data.productSearch.travellers.children.length;
                }

                return product;
            },
            _getFlightOnlyProductsData: function ($offers) {
                var products = [];
                $offers.each(function (i) {
                    var $offerItem = $(this);
                    var data = $offerItem.data('tracking-data');
                    var productSearch = $offerItem.data('tracking-product-search');
                    var position = (i + 1);

                    var travelDates = {
                        from: moment(data.offers["0"].departureFlight.departureDateTime).format('YYYY.MM.DD'),
                        to: moment(data.offers["0"].returnFlight.departureDateTime).format('YYYY.MM.DD')
                    };

                    try {
                        var product = {
                            name: data.offers["0"].departureFlight.departureAirport.code +
                            '-' + data.offers["0"].returnFlight.departureAirport.code,
                            id: data.offers["0"].departureFlight.flightNumber, //if available otherwise repeat the name
                            brand: data.offers["0"].tourOperator.code,
                            variant: travelDates.from + '/' + travelDates.to,
                            price: data.offers["0"].price.amount,
                            category: 'flight/' + data.location.country.code + '/' + data.airportIdentifier.name,
                            list: data.airportIdentifier.name,
                            position: position,
                            adults: productSearch.travellers.adults.length,
                            durationOfStay: productSearch.travelPeriod.duration,
                            travelDates: travelDates.from + '/' + travelDates.to,
                        };

                        if (typeof productSearch.travellers.children !== "undefined") {
                            product.children = productSearch.travellers.children.length;
                        }

                        products.push(product);
                    } catch (e) {
                        console.log(e);
                    }

                });

                return products;
            },
            _onClickHotelLink: function (e) {

                /**
                 * Triggered event
                 */
                if (typeof e.which === 'undefined') {
                    e.which = 1;
                }
                //right Click
                if (e.which === 3) {
                    return true;
                }

                e.preventDefault();
                e.stopImmediatePropagation();

                var $elem = $(e.currentTarget);
                var targetUrl = $elem.attr('href').trim();

                var offerData = this._getOfferData($elem);

                //(e.which === 1) - left Click
                // Not change location in case of middle btn click
                const eventCallback = (e.which === 1) ? function() {
                    document.location = targetUrl
                } : function() {};

                setTimeout(eventCallback, 2000);

                var product = {};
                if (this.option('siteArea') === 'hotelDestination') {
                    product = this._createHotelDestinationProduct(offerData, offerData.listName, offerData.offerIndex);
                } else {
                    product = this._createPackageDestinationProduct(offerData, offerData.listName, offerData.offerIndex);
                }

                window.dataLayer.push({
                    'event':'productClick',
                    product: product,
                    'eventCallback': eventCallback
                });

                return false;
            },
            _onClickFlightLink: function (e) {

                //right Click
                if (e.which === 3) {
                    return true;
                }

                e.preventDefault();
                e.stopImmediatePropagation();

                var $elem = $(e.currentTarget);
                var targetUrl = $elem.attr('href').trim();

                //(e.which === 1) - left Click
                // Not change location in case of middle btn click
                const eventCallback = (e.which === 1) ? function() {
                    document.location = targetUrl
                } : function() {};

                setTimeout(eventCallback, 2000);

                const products = this._getFlightOnlyProductsData($elem);

                window.dataLayer.push({
                    'event':'productClick',
                    product: products[0] ? products[0] : {},
                    // (e.which === 1) left btn Click
                    // Not change location in case of middle btn click
                    'eventCallback': eventCallback
                });

                return false;
            },
            _getOfferData: function ($elem) {
                var $offerItem = $elem.parents('[data-fcse-role="offer-item"]');
                var offerData = JSON.parse($offerItem.find('[data-fcse-favorites]').data('fcse-favorites').data);
                var $hotelDetails = $('[data-fcse-role="hotel-details"]');
                if ($hotelDetails.length) {
                    offerData = $.extend(
                        offerData, $hotelDetails.data(), $hotelDetails.data('fcse-booking-data'));
                }

                offerData = $.extend(offerData, $offerItem.data('gtm-product'));
                offerData.listName = $offerItem.data('group-name');
                offerData.offerIndex = $offerItem.data('fcse-offer-index');

                return offerData;
            }
        });

        return GtmListingPage;
    });



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/googletagmanager/GtmListingPage.js